import { ExternalUnit } from '../../models/external-units.model';
import { UnitSimulationAccessory } from '../../models/requests/simulation.model';

export namespace UnitConfigurationActions {
  export class SetSimulationAccessory {
    static readonly type = '[UnitConfiguration] Set Simulation Accessories';
    constructor(public accessories: UnitSimulationAccessory[] | undefined) {}
  }

  export class SetUpdatingAccessories {
    static readonly type = '[UnitConfiguration] Set Accessory Updating';
    constructor(public updating: boolean) {}
  }
  export class ClearState {
    static readonly type = '[UnitConfiguration] Clear State';
  }

  export class LoadExternalUnits {
    static readonly type = '[UnitConfiguration] Load External Units';
  }

  export class SetExternalUnits {
    static readonly type = '[UnitConfiguration] Set External Units';
    constructor(public externalUnits: ExternalUnit[]) {}
  }

  export class ResetExternalUnitsState {
    static readonly type = '[UnitConfiguration] Reset External Units state';
  }
}
